import { useState, useEffect } from 'react'
import { axiosInstance as api } from '../../utils/server'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { strings } from '../../lang/Lang'

function AddCompany(props) {
    const [name, setName] = useState()
    const [user_id, setUserID] = useState()
    const [image, setImage] = useState()
    const [status, setStatus] = useState(false)
    const [uploading, setUpload] = useState(false)
    const [authority, setAuthority] = useState()

    useEffect(async () => {
        loginStatus()
        const userAuthority = await AsyncStorage.getItem('@user_authority')
        setAuthority(userAuthority)
    }, [])

    const loginStatus = async () => {
        const login = await AsyncStorage.getItem('@user_token')
        if (!login) {
            props.history.push('/login')
        }
    }

    const createProduct = async () => {
        if ((!authority && name) || authority && name && user_id) {
            setStatus(strings.creating)
            setUpload(true)
            if (!authority) {
                const user_id = await AsyncStorage.getItem('@user_id')
                const response = await api.post('api/create-company', {
                    name,
                    users_ID: user_id
                })
                if (response.data.status) {
                    props.history.push('/')
                } else {
                    setStatus(strings.businessLimit)
                }
            } else {
                const response = await api.post('api/create-company', {
                    name,
                    users_ID: user_id
                })
                if (response.data.status) {
                    props.history.push('/')
                } else {
                    setStatus('Yetkisiz Erişim Saptandı!')
                }
            }

        }
        else {
            setStatus(strings.fillData)
        }

    }

    const handleSubmit = (evt) => {
        evt.preventDefault();
        createProduct()
    }

    const addPhoto = async (e) => await getBase64(e.target.files[0])

    const getBase64 = (file) => {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
            setImage(reader.result)
            return reader.result
        };
        reader.onerror = function (error) {
            console.log("Error: ", error)
        }
    }

    return (
        <>
            <h1 className="h3 mb-4 text-gray-800">{strings.addCompany}</h1>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-6">
                        <div className="row">
                            <div className="col-12">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="basic-addon1">{strings.companyName}</span>
                                    </div>
                                    <input type="text" className="form-control" value={name} onChange={e => setName(e.target.value)} />
                                </div>
                            </div>
                            {
                                authority ?
                                    <div className="col-12">
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text" id="basic-addon1">User ID</span>
                                            </div>
                                            <input type="text" className="form-control" value={user_id} onChange={e => setUserID(e.target.value)} />
                                        </div>
                                    </div> : null
                            }

                        </div>
                        <button disabled={uploading} className="btn btn-danger btn-icon-split mt-2">
                            <span className="text">{strings.addCompany}</span>
                        </button>
                    </div>

                    {/* <div className="col-6">
                        <div className="form-group">
                            <label>Şirket logosunu yükleyin. (zorunlu değil.)</label>
                            <input type="file" className="form-control-file" disabled={uploading} onChange={addPhoto} />
                        </div>
                    </div> */}

                </div>
            </form>
            <div className="mt-5">
                <h2>{status ? status : null}</h2>
            </div>
        </>
    )
}

export default AddCompany